import type { ReactNode } from 'react';
import { cn } from './cn';

export function Kbd({ className, children }: { className?: string; children: ReactNode }) {
  return <kbd className={cn('inline-flex min-w-5 items-center justify-center rounded-sm border border-border bg-surface-2 px-1 font-mono text-[11px] leading-4 text-fg-muted', className)}>{children}</kbd>;
}
